/**
 * Normalize tracked candidate IDs for Set lookups.
 * React Query IndexedDB persist is JSON-only — never store Set in query cache
 * (see development-workflow.mdc).
 */
export function toTrackedCandidateIdSet(ids: unknown): Set<string> {
  if (ids instanceof Set) return ids;
  if (Array.isArray(ids)) return new Set(ids.map(String));
  return new Set();
}
